import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
interface ProblemProofProps {
  onScrollToSection?: (sectionId: string) => void;
}
export function ProblemProof({
  onScrollToSection
}: ProblemProofProps) {
  const {
    t
  } = useLanguage();
  const stats = [{
    number: t('problem.stat1.value'),
    label: t('problem.stat1.label')
  }, {
    number: t('problem.stat2.value'),
    label: t('problem.stat2.label')
  }, {
    number: t('problem.stat3.value'),
    label: t('problem.stat3.label')
  }];
  const handleWaitlistClick = () => {
    if (onScrollToSection) {
      onScrollToSection('waitlist');
    }
  };
  return <section className="w-full py-32 px-6 bg-black text-white" data-id="element-311">
      <div className="max-w-5xl mx-auto" data-id="element-312">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-313">
          <h2 className="text-6xl md:text-8xl font-black mb-8 uppercase tracking-tighter leading-none" data-id="element-314">
            {t('problem.title')}
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-315">
            {t('problem.subtitle')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-316">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="border-2 border-white p-8 text-center" data-id="element-317">
              <p className="text-5xl font-black mb-4" data-id="element-318">{stat.number}</p>
              <p className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-319">
                {stat.label}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="border-t border-b border-white py-12 text-center" data-id="element-320">
          <p className="text-2xl font-black mb-6 uppercase tracking-tight" data-id="element-321">
            {t('problem.impact.title')}
          </p>
          <p className="text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-322">
            {t('problem.impact.text')}
          </p>
          <button onClick={handleWaitlistClick} className="px-12 py-5 bg-white text-black font-black text-lg hover:bg-gray-200 border-2 border-white transition-all duration-300 uppercase tracking-widest rounded-full shadow-lg hover:shadow-xl hover:scale-105" data-id="element-323">
            {t('problem.cta')}
          </button>
        </motion.div>
      </div>
    </section>;
}